module.exports = __webpack_public_path__ + "assets/img/black.ea8c464d.png";